// Permissions hidden from sidebar and /management assign-permission UI.
// Comment out entries here to show them again.
export const HIDDEN_PERMISSIONS = [
  "Students",
  "Parents",
  "Classes",
  "Library",
  "Courses",
  "HRMS",
  "FeeManagement",
  "Reports",
  "WellnessSuite",
  "PTC",
];

export const PERMISSION_LABELS = {
  UserManagement: "Administrator",
};

export const filterVisiblePermissions = (permissions = []) =>
  permissions.filter((permission) => !HIDDEN_PERMISSIONS.includes(permission.name));

export const formatPermissionLabel = (name) => PERMISSION_LABELS[name] || name;

export const formatPermissionList = (permissions = []) =>
  permissions
    .filter((name) => !HIDDEN_PERMISSIONS.includes(name))
    .map(formatPermissionLabel)
    .join(", ");
